import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/ForgotPassword.css";
import loginImg from "../../assets/loginImage.jpeg";
import Navbar from "../../layouts/Navbar";
import axios from "axios";
import logo from "../../assets/Logo.png";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import { EMAIL_REGEX } from "../../constants/common";
import { Link } from "react-router-dom";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // const emailRegex =
      //   /^[^\s@]+@[^\s@]+\.(?:com|in|org|net|edu|gov|co\.uk|io|info)$/i;
      if (!EMAIL_REGEX.test(email)) {
        toast.error("Invalid email address");
        return;
      }
      const response = await axios.get(
        `https://yelospace.com/api/is-exist/user/${email}`
      );
      if (response.data.status === 200) {
        setIsError(false);
        const res = await axios.post(
          `https://yelospace.com/api/send-otp/${email}`
        );
        if (res.data.status === 200) {
          localStorage.setItem("email", email);
          // Navigate to verify-otp page
          navigate("/verify-otp");
        } else {
          setErrorMessage("Error,Please try again later.");
          setIsError(true);
        }
      } else if (response.data.status === 404) {
        setErrorMessage("User not found, please try again.");
        setIsError(true);
        console.error("Email does not exist");
        // Handle the case where email does not exist (e.g., show an error message)
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };

  return (
    <>
      {/* <Navbar /> */}
      <ToastContainer />
      <div className="forgot-password-container">
      <div className="w-100 d-flex justify-content-center">
        <div className="left-panel">
          <img src={loginImg} alt="Left Panel Image" />
        </div>
        <div className="right">
        <div className="w-100 d-flex justify-content-center">
              <Link to="/">
                <img src={logo} className="logo-img" alt="Left Panel Image" />
              </Link>
            </div>
          <div className="w-100 d-flex justify-content-center">
          <div className="forget-password-heading">
            <h2>Forgot Password ?</h2>
          </div>
         </div>
          <form onSubmit={handleSubmit}>
            <div className="input-group-custum">
              <label className="label-custum" htmlFor="email">
                Enter your registered Email
              </label>
              <input
                type="email"
                id="email"
                placeholder="Email *"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              {isError && <p className="text-danger">{errorMessage}</p>}
              <label className="label-custum" htmlFor="email">
                An OTP will be sent to your registered email
              </label>
            </div>
            <div className="d-flex justify-content-center w-100">
            <button type="submit" className="submit-btn">
              Send OTP
            </button>
            </div>
          </form>
          <div className="w-100 d-flex justify-content-center">
          <div className="back-to-login">
            <a href="/login">
              Back to{" "}
              <span style={{ textDecoration: "underline" }}>Login </span>{" "}
            </a>
          </div>
          </div>
        </div>
        </div>
      </div>
    </>
  );
}

export default ForgotPassword;
